var map = {
	"./aliases.json": 5479,
	"./il_g1_ela.json": 8550,
	"./il_g1_math.json": 6500,
	"./il_g1_science.json": 7172,
	"./il_g1_socialscience.json": 7281,
	"./il_g2_ela.json": 8475,
	"./il_g2_math.json": 9627,
	"./il_g2_science.json": 7853,
	"./il_g2_socialscience.json": 2492,
	"./il_g3_ela.json": 3816,
	"./il_g3_math.json": 4562,
	"./il_g3_science.json": 4710,
	"./il_g3_socialscience.json": 4015,
	"./il_g4_ela.json": 4437,
	"./il_g4_math.json": 9657,
	"./il_g4_science.json": 5679,
	"./il_g4_socialscience.json": 4154,
	"./il_g5_ela.json": 8674,
	"./il_g5_math.json": 8168,
	"./il_g5_science.json": 7752,
	"./il_g5_socialscience.json": 5941,
	"./il_g6_ela.json": 3047,
	"./il_g6_math.json": 3503,
	"./il_g6_science.json": 8545,
	"./il_g6_socialscience.json": 2480,
	"./il_g7_ela.json": 8628,
	"./il_g7_math.json": 7542,
	"./il_g7_science.json": 8090,
	"./il_g7_socialscience.json": 4323,
	"./il_g8_ela.json": 9953,
	"./il_g8_math.json": 5741,
	"./il_g8_science.json": 547,
	"./il_g8_socialscience.json": 8174,
	"./il_gk_ela.json": 8336,
	"./il_gk_math.json": 8874,
	"./il_gk_science.json": 9550,
	"./il_gk_socialscience.json": 6279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1800;